import styles from './FJImageEnhancerRight.module.less';
import PropTypes from 'prop-types';
import FJDragBox from '../../../common/components/FJDragBox/FJDragBox';
import FJImageEnhancerCreationsContainer from '../FJImageEnhancerCreations/FJImageEnhancerCreationsContainer';
import FJLocalStore from '../../../store/FJLocalStore';
import FJUtil from '../../../util/FJUtil';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import classNames from 'classnames';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJImageEnhancerHeaderButtons from './FJImageEnhancerHeaderButtons.jsx';

const FJImageEnhancerRight = props => {
    const {
        headerTabIndex,
        uploadImg,
        setIsDraggingFile,
        taskStatus,
        imageEnhancerCreationList,
        downloadAll,
        batchDownloadLoading,
        isEmptyCreationList,
    } = props;

    const renderDownload = () => {
        if (FJUtil.isGeneratingStatus(taskStatus) || headerTabIndex !== 0) return null;
        // 在独立AI工具页，如果只有一个图片，则不显示下载按钮
        if (!window.isEditPage && imageEnhancerCreationList.length <= 1) return null;

        if (window.isEditPage) {
            return <FJImageEnhancerHeaderButtons />;
        } else {
            return (
                <div className={styles.download_box}>
                    <FJIconButton
                        onClick={downloadAll}
                        className={classNames(styles.download_all, batchDownloadLoading && styles.loading)}
                        textClassName={styles.download_text}
                        text={FJLocalStore._('download-all')}
                        isLoading={batchDownloadLoading}
                        strokeColor={'#FF47D0'}
                        loadingSize={16}
                    />
                </div>
            );
        }
    };
    return (
        <FJDragBox
            multipleUpload={true}
            setIsDragging={setIsDraggingFile}
            uploadFile={uploadImg}
            className={classNames(
                styles.app_right,
                isEmptyCreationList && headerTabIndex === 0 && styles.empty_creation_list,
            )}
        >
            <FJDisplayHeaderContainer rightChildren={renderDownload()} isHideBottomLine={isEmptyCreationList} />

            <FJImageEnhancerCreationsContainer active={headerTabIndex === 0} />

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </FJDragBox>
    );
};
FJImageEnhancerRight.propTypes = {
    headerTabIndex: PropTypes.number,
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    imageEnhancerCreationList: PropTypes.array,
    taskStatus: PropTypes.string,
    downloadAll: PropTypes.func,
    batchDownloadLoading: PropTypes.bool,
    isEmptyCreationList: PropTypes.bool,
};
export default FJImageEnhancerRight;
